"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isFinite = _interopRequireDefault(require("lodash/isFinite"));

var _parseInt = _interopRequireDefault(require("lodash/parseInt"));

var _moment = _interopRequireDefault(require("moment"));

var _Types = require("../Types");

var _Types$Double$Types$I;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function isWithinNumericRange(minValue, maxValue) {
  return function (value) {
    return value >= minValue && value <= maxValue;
  };
}

function isValidTimeValue(strTime) {
  var time = (0, _moment["default"])(strTime, 'HH:mm', true);
  return time.isValid();
}

function isValidNumberValue(value, numberParser) {
  var isValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var parsedNumber = numberParser(value);
  var parsedNumberAsString = parsedNumber.toString();
  return (0, _isFinite["default"])(parsedNumber) && parsedNumberAsString === value.toString() && isValid(parsedNumber);
}

var INT16_MINIMUM_VALUE = -32768;
var INT16_MAXIMUM_VALUE = 32767;
var INT32_MINIMUM_VALUE = -2147483648;
var INT32_POSITIVE_MINIMUM_VALUE = 0;
var INT32_MAXIMUM_VALUE = 2147483647;
var INT64_MINIMUM_VALUE = -9223372036854775808;
var INT64_MAXIMUM_VALUE = 9223372036854775807;

var _default = (_Types$Double$Types$I = {}, _defineProperty(_Types$Double$Types$I, _Types.Types.Double, function (value) {
  return isValidNumberValue(value, parseFloat);
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Int16, function (value) {
  return isValidNumberValue(value, _parseInt["default"], isWithinNumericRange(INT16_MINIMUM_VALUE, INT16_MAXIMUM_VALUE));
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Int32, function (value) {
  return isValidNumberValue(value, _parseInt["default"], isWithinNumericRange(INT32_MINIMUM_VALUE, INT32_MAXIMUM_VALUE));
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Int32Positive, function (value) {
  return isValidNumberValue(value, _parseInt["default"], isWithinNumericRange(INT32_POSITIVE_MINIMUM_VALUE, INT32_MAXIMUM_VALUE));
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Int64, function (value) {
  return isValidNumberValue(value, _parseInt["default"], isWithinNumericRange(INT64_MINIMUM_VALUE, INT64_MAXIMUM_VALUE));
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Single, function (value) {
  return isValidNumberValue(value, parseFloat);
}), _defineProperty(_Types$Double$Types$I, _Types.Types.Time, function (value) {
  return isValidTimeValue(value);
}), _Types$Double$Types$I);

exports["default"] = _default;